import { Button, styled, Typography } from '@mui/material';

export const UploadImage = styled(Button)(
  ({ theme, $hasError }) => `
  height: 226px;
  width: 100%;
  border: 1px solid ${
    $hasError ? theme.palette.brand.red : theme.palette.secondary.dark
  };
  border-radius: 7px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  text-align: center;

  gap: 20px;
  padding:0px;
`,
);

export const Image = styled('img')`
  height: 100%;
  width: 100%;
  background-size: contain;
  background-position: bottom;
  background-repeat: no-repeat;
  border-radius: 6px;
`;

export const StyledFileName = styled(Typography)`
  word-break: break-word;
`;
